export enum ASK_AI_BULK {
    /**
     * @value Add a row after
     */
    ADD_ROW_AFTER = 'WREX_TABLE.TABLE_TOOLBAR_ADD_ROW_AFTER',
    /**
     * @value Answer
     * @description Ask lumapps answer label
     */
    ANSWER = 'ASK_AI_RULES.ANSWER',
    /**
     * @value Bulk
     */
    BULK = 'ASK_AI_BULK.BULK',
    /**
     * @value Type in or paste a list of queries
     */
    PLACEHOLDER = 'ASK_AI_BULK.PLACEHOLDER',
    /**
     * @value Query
     */
    QUERY = 'LOOKER_PLATFORM_SEARCH_DASHBOARD_QUERY',
    /**
     * @value Run
     */
    RUN = 'MICROAPP.RUN',
    /**
     * @value Stop the streaming
     * @description Label of the streaming cancellation button in Ask AI Conversation
     */
    STOP_STREAMING = 'ASK_AI_CONVERSATION.STOP_STREAMING',
}
